// TODO(laurentmeyer 2022-08-16) @attachment-name implement a warning system instead of a custom card
import {Trans} from '@lingui/macro';
import {isString} from 'lodash';
import React, {FC, ReactNode} from 'react';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {InlineBannerTypesEnum} from '../../../../components/inlineBanner/inlineBanner';
import {RuleDefaultCardTypesEnum} from '../../ruleActionConditionHelpers';
import {AttachmentNameContainsCondition} from '../../ruleConditionModel';
import {RuleConditionDefinition} from '../../ruleParameterModel';
import {maybeRuleActionConditionTooltip} from '../ruleActionConditionTooltip';
import {RuleConditionIcon} from '../ruleConditionIcon';
import {
  MultilineRuleParameterCardDefaultTitleStyled,
  RuleMultilineParameterCard,
} from '../ruleMultilineParameterCard';
import {renderGenericRuleParameters} from './ruleDefaultActionConditionCard';

/*
 * Props.
 */

interface RuleAttachmentNameConditionCardProps {
  condition: AttachmentNameContainsCondition;
  conditionDefinition: RuleConditionDefinition | undefined;
  isDisabled?: boolean;
  errorMessage?: ReactNode;
  onUpdate: HandlerOf<AttachmentNameContainsCondition>;
  onDelete?: HandlerOf<AttachmentNameContainsCondition>;
}

/*
 * Component.
 */

export const RuleAttachmentNameConditionCard: FC<RuleAttachmentNameConditionCardProps> = (props) => {
  const {condition, conditionDefinition, isDisabled, errorMessage, onUpdate, onDelete} = props;

  // This should not happen, but safety check.
  const errorLabel = <Trans id="definition-condition-not-found">Condition {condition.type} not found</Trans>;
  if (!conditionDefinition) {
    return <RuleMultilineParameterCard icon={<RuleConditionIcon id={condition.type} />} title={errorLabel} />;
  }

  const onCancel = onDelete && !isDisabled ? () => onDelete(condition) : undefined;

  const {
    parameters: [comparatorParameter, textParameter],
  } = renderGenericRuleParameters(
    condition,
    conditionDefinition,
    RuleDefaultCardTypesEnum.CONDITION,
    onUpdate,
    conditionDefinition.parameters,
    isDisabled,
  );

  const {text} = condition.params;
  const maybeWarningMessage =
    !errorMessage && text && isString(text) && text.includes('.') ? (
      <Trans id="rule-attachment-name-warning-punctuation">
        {
          'It looks like you included the file extension. For more control over extensions, you can use the "Attachment extension contains" condition.'
        }
      </Trans>
    ) : undefined;

  const title = (
    <>
      <MultilineRuleParameterCardDefaultTitleStyled>
        {conditionDefinition.name}
      </MultilineRuleParameterCardDefaultTitleStyled>
      {maybeRuleActionConditionTooltip(conditionDefinition)}
      {comparatorParameter}
    </>
  );

  return (
    <RuleMultilineParameterCard
      icon={<RuleConditionIcon id={condition.type} />}
      title={title}
      onCancel={onCancel}
      errorMessage={errorMessage ?? maybeWarningMessage}
      errorType={errorMessage ? InlineBannerTypesEnum.ERROR : InlineBannerTypesEnum.WARNING}
    >
      {textParameter}
    </RuleMultilineParameterCard>
  );
};
